export interface INavigationRoute {
  name: string
  displayName: string
  meta: { icon: string }
  children?: INavigationRoute[]
}

export default {
  root: {
    name: '/long-stay-permit',
    displayName: 'Long Stay Permit',
  },
  routes: [
    {
      name: 'services-home',
      displayName: 'Services',
      meta: {
        icon: 'settings',
      },
    },
    {
      name: 'LSP-HOME',
      displayName: 'Long Stay Permit',
      meta: {
        icon: 'vuestic-iconset-dashboard',
      },
    },
    {
      name: 'LSP-FAQ',
      displayName: 'FAQ',
      meta: {
        icon: 'quiz',
      },
    },
    {
      name: 'LSP-HTA',
      displayName: 'How to Apply',
      meta: {
        icon: 'quiz',
      },
    },
    {
      name: 'LSP-TAC',
      displayName: 'Terms and Agreement',
      meta: {
        icon: 'quiz',
      },
    },
  ],
}
